export default __webpack_public_path__ + "2e1d9b3a1e6c82db6d596bd26c0fd70e.svg";